import { createAction, props } from '@ngrx/store'
import { TokenInterface } from '@shared/interfaces/app.state.interfaces'

export const terminosCondiciones = createAction(
    '[TerminosCondiciones] Token',
    props<{ item: TokenInterface }>()

)